import { Icon, ICON_SIZES } from "src/apps/components/icon/Icon";
import { ICON_PATHS } from "src/apps/components/icon/IconSVGPaths";
import { useTheme } from "src/apps/providers/ThemeStore";
import styled from "styled-components";
import { OpenAdminAtomicBanner } from "./OpenAdminAtomicBanner";
import { useTranslations } from "src/apps/hooks/useTranslations";
import { Button } from "src/apps/components/button/Button";
import { BasicBannerProps } from "./OpenAdminBannerByStatus";

export const CompletedOpenAdminBanner = ({
  title,
  description,
  buttonText,
  onButtonClick,
  isLoading,
  isDisabled,
}: BasicBannerProps) => {
  const { successColor } = useTheme();
  const { t } = useTranslations();

  return (
    <OpenAdminAtomicBanner
      title={t(title)}
      description={description ? t(description) : undefined}
      borderColor={successColor}
      leftAlign="flex-start"
      leftComponent={
        <StatusIconContainer>
          <Icon size={ICON_SIZES.s24} color={successColor} path={ICON_PATHS.CHECK_CIRCLE_THIN} />
        </StatusIconContainer>
      }
      rightComponent={
        buttonText ? (
          <Button
            onClick={onButtonClick ?? (() => {})}
            text={t(buttonText)}
            isLoading={isLoading}
            disabled={isDisabled}
          />
        ) : undefined
      }
    />
  );
};

const StatusIconContainer = styled.div`
  display: flex;
  align-items: center;
`;
